module.exports = __webpack_public_path__ + "static/img-featured-contributor-rithika-ed10a8cc6e873dcf325b7307fbfd3da7.jpg";